export default function ntPaymentConfirm(
  state = { error: null, success: null, processing: "" },
  action
) {
  switch (action.type) {

    case 'NT_PAYMENT_CONFIRM_SUCCESS':
      return {...state, ...{success: action.success,error:null}};
    case 'NT_PAYMENT_CONFIRM_ERROR':
      return {...state, ...{error: action.error.response,success:null}};
    case 'NT_PAYMENT_CONFIRM_PROCESSING':
      return {...state, ...{processing: action.processing}};
    case 'RESET_NT_PAYMENT_CONFIRM':
      return {...state, ...{success:null,error:null}};
    default:
      return state;
  }
}
